module.exports = __webpack_public_path__ + "static/media/info_24_px.8b48c1f3.svg";